import React, {Component} from 'react';
import {gpn} from "../GPN"
import Field from "../sections/MUI/Field";
import Select from "../sections/MUI/Select";
import SignatureCanvas from 'react-signature-canvas'
import Button from "../sections/MUI/Button";
import req from "../req";
import config from "../config";
import Modal from "../sections/MUI/Modal";
import jMoment from "jalali-moment";
import {toast} from "react-toastify";
import ModalLoading from "../sections/ModalLoading";
import Icon from "../sections/MUI/Icon";
import File from "../sections/MUI/File";
import axios from "axios";
import {Link} from "react-router";
import ModalAuthVideo from "../sections/ModalAuthVideo";

// import ModalAuthVideo from "../sections/ModalAuthVideo";

class Home extends Component {

    items = [
        {t: "راهنمای خرید اقساطی", i: "question-circle", r: "/help"},
        {t: "درخواست تسهیلات", i: "money-bill-wave", r: "/facilities"},
        {t: "خدمات", i: "wrench", r: "/services"},
        {t: "سفارشات", i: "sort", r: "/orders"},
        {t: "پرداخت ها", i: "money-check-edit-alt", r: "/payments"},
        {t: "پروفایل", i: "user", r: "/profile"},
    ];

    state = {
        info: null,
        noChangeInfo: null,
        isValid: "loading",
        file: null,

        terms: "",

        authVideoText: "",

        modalTerms: false,
        loading: false,

        step: null,

        lastOrderStep: "ثبت شده",

        order: null,
        payment: null,

        estelamAmount: 0,

        isUploadValidation: false,

        modalAuthVideo: false
    };

    constructor() {
        super();
        this.sigCanvas = React.createRef();
    }

    componentDidMount() {
        this.props.setTitle("قسطی تک");
        this.setState({
            info: this.props.info,
            noChangeInfo: this.props.info
        });
        this.getStep();
        this.checkValidation();
        // this.getTerms();
        this.getLastOrderStep();
    }


    getInfo() {
        req.getRequest(`${config.api}/user/info`)
            .then(r => {
                if (r) {
                    this.setState({
                        info: r,
                        noChangeInfo: r
                    });
                }
            })
            .catch(err => {
            });
    }

    getStep() {
        req.getRequest(`${config.api}/user/step`)
            .then(r => {
                this.setState({
                    step: r.step,
                    order: r.order,
                    payment: r.payment,
                    estelamAmount: r.estelamAmount
                });

                if (r.step.toString().trim().toLowerCase() === "video") {
                    this.getAuthVideoText();
                }
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getLastOrderStep() {
        req.getRequest(`${config.api}/user/last-order/step`)
            .then(r => {
                let s = r ? r.step ? r.step.toString().trim() : "" : "";
                this.setState({
                    lastOrderStep: s
                });
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getAuthVideoText() {
        req.getRequest(`${config.api}/user/auth-video-text`)
            .then(r => {
                    let {authVideoText} = r;
                    authVideoText = authVideoText ? authVideoText.toString().trim() : "";
                    if (authVideoText === "") {
                        let {fullName} = this.state;
                        authVideoText = `من  ${fullName.toString().trim()}  با علم و آگاهی کامل نسبت به شرایط، ضوابط، و برابر توافق نامه شرکت تکین آنوش در سایت قسطی تک ثبت نام می نمایم.`
                    }
                    authVideoText = authVideoText.replace(/  /g, " ").trim();
                    this.setState({authVideoText});
                }
            )
            .catch(err => {
                config.handleError(err);
            });
    }

    checkValidation() {
        req.getRequest(`${config.api}/user/validation`)
            .then(r => {
                const {status} = r;
                this.setState({
                    isValid: status === 1 ? "valid" : "invalid"
                });
            })
            .catch(err => {
                this.setState({
                    isValid: "invalid"
                });
            });
    }

    getTerms() {
        req.getRequest(`${config.api}/user/terms`)
            .then(r => {
                this.setState({
                    terms: r.terms
                });
            })
            .catch(err => {
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.setState({
                info: this.props.info,
                noChangeInfo: this.props.info
            });
        }
    }

    submitInfo() {
        let {info} = this.state;
        let {
            fullName,
            nationalCode,
            fatherName,
            birthDate,
            shenasnameh,
            postalCode,
            sokoonat,
            address,
            job,
            elatMorajeeh,
            nahveAshnayei
        } = info;
        let signature = this.sigCanvas.current.toDataURL("image/png");
        let error = "";
        if (fullName === "" && error === "") {
            error = "نام و نام خانوادگی را وارد کنید";
        }
        if (nationalCode.length !== 10 && error === "") {
            error = "کد ملی معتبر نیست";
        } else if (nationalCode.length === 10 && error === "") {
            const check = +nationalCode[9];
            const sum = nationalCode.split('').slice(0, 9).reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
            let result = sum < 2 ? check === sum : check + sum === 11;
            if (!result) {
                error = "کد ملی وارد شده صحیح نیست!";
            }
        }
        if (fatherName === "" && error === "") {
            error = "نام پدر را وارد کنید";
        }
        if (birthDate.length !== 10 && error === "") {
            error = "تاریخ تولد را وارد کنید";
        } else if (birthDate.length === 10 && error === "") {
            let date = jMoment.from(birthDate, "fa", "jYYYY/jMM/jDD");

            if (!date.isValid()) {
                error = "تاریخ تولد نامعتبر است"
            }
        }
        if (shenasnameh === "" && error === "") {
            error = "شماره شناسنامه را وارد کنید";
        }
        if (job === "" && error === "") {
            error = "شغل را وارد کنید";
        }
        if (postalCode.length !== 10 && error === "") {
            error = "کد پستی معتبر نیست";
        }
        if (sokoonat === "" && error === "") {
            error = "وضعیت سکونت را وارد کنید";
        }
        if (address === "" && error === "") {
            error = "آدرس را وارد کنید";
        }
        if (elatMorajeeh === "" && error === "") {
            error = "عفت مراجعه را وارد کنید";
        }
        if (nahveAshnayei === "" && error === "") {
            error = "نحوه آشنایی با شرکت را وارد کنید";
        }
        if (this.sigCanvas.current.isEmpty() && error === "") {
            error = "امضای خود را ثبت کنید"
        }

        if (error === "") {
            this.setState({
                loading: true
            });
            axios.post(`${config.api}/user/info?token=${config.token}`, JSON.stringify({
                fullName,
                nationalCode,
                fatherName,
                birthDate,
                job,
                shenasnameh,
                postalCode,
                sokoonat,
                address,
                elatMorajeeh,
                nahveAshnayei,
                signature
            }), {
                headers: {
                    "content-type": "application/json"
                }
            })
                .then(r => {
                    toast.success("اطلاعات شما ثبت شد.");
                    setTimeout(() => {
                        this.setState({
                            loading: false,
                            noChangeInfo: {
                                fullName,
                                nationalCode,
                                fatherName,
                                birthDate,
                                shenasnameh,
                                job,
                                postalCode,
                                sokoonat,
                                address,
                                elatMorajeeh,
                                nahveAshnayei,
                                signature
                            }
                        });
                        document.location.reload();
                    }, 2000);
                })
                .catch(err => {
                    console.error(err);
                    this.setState({loading: false});
                    config.handleError(err);
                });
        } else {
            toast.error(error);
        }
    }

    submitValidation() {
        let {file} = this.state;
        if (file) {
            let params = new FormData();
            params.append('file', file);

            this.setState({
                isUploadValidation: true
            });
            toast.info("در حال آپلود لطفاً شکیبا باشید ...");
            axios.post(`${config.api}/user/validation`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                },
                headers: {
                    'content-type': 'multipart/form-data',
                    "authorization": config.token
                }
            })
                .then(r => {
                    this.setState({
                        isUploadValidation: false
                    });
                    toast.success("فایل اعتبارسنجی با موفقیت آپلود شد.");
                    document.location.reload();
                })
                .catch(err => {
                    this.setState({
                        isUploadValidation: false
                    });
                    toast.error("خطایی رخ داده است!");
                });
        } else {
            toast.error("فایل اعتبارسنجی وارد نشده!");
        }
    }

    orderStatusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("سفارش موفق") || status.includes("واریز شده")) {
            color = "#139f01";
        } else if (status.includes("لغو") || status.includes("واریز نشده") || status.includes("ناموفق")) {
            color = "#c00e0e"
        } else if (status.includes("اولیه") || status.includes("نامشخص")) {
            color = "#959595"
        }
        return color;
    }

    paymentStatusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("پرداخت موفق")) {
            color = "#139f01";
        } else if (status.includes("پرداخت ناموفق") || status.includes("پرداخت نشد")) {
            color = "#c00e0e"
        }
        return color;
    }

    handleUploadProfilePhoto(base64Photo = "") {
        req.postRequest(`${config.api}/user/profile-photo`, {photo: base64Photo})
            .then(r => {
                try {
                    this.props.getInfo(true);
                } catch (err) {
                }
            })
            .catch(err => {
            });
    }

    handleUploadAuthVideo(blob = null) {
        if (!blob) {
            return null;
        }
        let params = new FormData();
        params.append("video", blob, `video-${config.random(1000000000, 9999999998)}.webm`);

        axios.post(`${config.api}/user/auth-video/upload`, params, {
            headers: {
                'content-type': 'multipart/form-data',
                "authorization": config.token
            },
            timeout: 18 * 60 * 1000
        })
            .then(r => {
                this.setState({
                    modalAuthVideo: false
                });
                toast.success("احراز هویت با موفقیت انجام شد!");
                setTimeout(() => {
                    document.location.reload();
                }, 2000);
            })
            .catch(err => {
                this.setState({modalAuthVideo: false});
                let errorBody = err ? err.response ? err.response.data ? err.response.data : {message: "خطا!"} : {message: "خطا!"} : {message: "خطا!"};
                config.handleError(errorBody);
                setTimeout(() => {
                    toast.info("دوباره تلاش کنید ...");
                    setTimeout(() => {
                        this.setState({modalAuthVideo: true});
                    }, 2000);
                }, 3000);
            });
    }

    createEstelamPayment() {
        this.setState({
            loading: true
        });
        req.postRequest(`${config.api}/user/est-payment`, {})
            .then(r => {
                this.setState({loading: false});
                let url = r ? r.url ? r.url.toString() : "" : "";
                if (url !== "") {
                    url = `https://api.takinanoosh.ir/brg?url=` + encodeURIComponent(url);
                    if (typeof document !== "undefined") {
                        document.location.href = url;
                    } else if (typeof window !== "undefined") {
                        window.open(url);
                    } else {
                        try {
                            this.props.navigate(url);
                        } catch (err) {
                        }
                    }
                } else {
                    toast.error("با عرض پوزش، از طرف درگاه پرداخت خطایی رخ داده است؛ دقایقی دیگر مجدد تلاش بفرمایید! از صیر و شکیبایی شما سپاسگزاریم")
                }
            })
            .catch(err => {
                try {
                    config.handleError(typeof err === "string" ? {error: err} : err);
                } catch (err) {
                    toast.error("خطایی رخ داده است!");
                }
                this.setState({loading: false});
            });
    }

    render() {
        const {isValid, loading, step, order, payment, lastOrderStep} = this.state;

        if (!step) {
            return null;
        }

        return (
            <div className="home">
                <ModalLoading loading={loading || isValid === "loading"}/>
                {step === "final" ?
                    <>
                        <div className="home-items">
                            {
                                lastOrderStep?.toString().trim() !== "" ?
                                    <div className="last-order-step">
                                        آخرین سفارش شما در مرحله <strong>{lastOrderStep}</strong> می باشد
                                    </div>
                                    : null
                            }
                            <div className="row justify-content-center">
                                {
                                    this.items.map((it, i) =>
                                        <div className="col-12" key={"item" + i}>
                                            <div className="box" onClick={() => this.props.navigate(it.r)}>
                                                <Icon i={it.i}/>
                                                <span className="title">{it.t}</span>
                                            </div>
                                        </div>
                                    )
                                }

                            </div>
                        </div>

                        {order ?
                            <div className="order-status">
                                <div className="order-status">
                                    <div className="state">
                                        وضعیت آخرین سفارش شما:&nbsp;<span className="status"
                                                                          style={{color: this.orderStatusColor(order)}}>{order}</span>
                                    </div>

                                    <div className="link">
                                        <Link to="/orders">لیست سفارشات</Link>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                        {payment ?
                            <div className="payment-status">
                                <div className="state">
                                    وضعیت آخرین پرداخت شما:&nbsp;<span className="status"
                                                                       style={{color: this.paymentStatusColor(payment)}}>{payment}</span>
                                </div>

                                <div className="link">
                                    <Link to="/payments">لیست پرداخت ها</Link>
                                </div>
                            </div>
                            : null
                        }
                    </>
                    : step === "info" ?
                        this.infoSection()
                        :
                        step === "video" ?
                            this.videoSection()
                            :
                            step === "estelamPayment" ?
                                this.estelamPaymentSection()
                                : this.validationSection()
                }
            </div>
        );
    }

    estelamPaymentSection() {
        let {estelamAmount} = this.state;
        return (
            <>
                <p className="hint">کاربر گرامی!</p>
                <p className="hint">جهت ادامه مراحل اخد تسهیلات و خرید کالا، می بایست استعلام هویتی شما انجام شود؛ هزینه
                    استعلام هویتی <strong>{config.priceFormatter(estelamAmount)} تومان </strong>می باشد:</p>
                <br/>
                <Button icon="check"
                        onClick={() => this.createEstelamPayment()}
                        backgroundColor="#119b11">پرداخت {config.priceFormatter(estelamAmount)} تومان و ادامه
                    مراحل</Button>
            </>
        );
    }

    videoSection() {
        let {authVideoText, modalAuthVideo, info} = this.state;
        let hasProfilePhoto = info ? info.profilePhoto ? info.profilePhoto.toString().trim() : "" : "";
        hasProfilePhoto = hasProfilePhoto !== "";
        authVideoText = authVideoText ? authVideoText.toString().trim() : "";
        if (authVideoText === "") {
            return null;
        }
        return (
            <>
                {
                    modalAuthVideo ?
                        <ModalAuthVideo
                            handleUploadAuthVideo={this.handleUploadAuthVideo.bind(this)}
                            handleUploadProfilePhoto={this.handleUploadProfilePhoto}
                            hasProfilePhoto={hasProfilePhoto}
                            display={modalAuthVideo}
                            authText={authVideoText}
                            onCloseClick={() => this.setState({modalAuthVideo: false})}/>
                        : null
                }
                <section className="auth-video">
                    <h1>احراز هویت</h1>
                    <p className="hint">کاربر عزیز! برای ادامه مراحل درخواست تسهیلات می بایست هویت شما تأیید شود!</p>
                    <br/>
                    <p className="hint" style={{margin: "8px 2px", color: "#313131", fontWeight: "bold"}}>برای احراز
                        هویت
                        باید دکمه زیر را انتخاب و متن نمایش داده شده را با صدای رسا، در مکانی
                        خلوت و بدون سروصدا جلوی دوربین
                        با صدای بلند بخوانید و سپس دکمه ارسال ویدیو را انتخاب نمایید.</p>
                    <br/>
                    <Button icon="video" onClick={() => this.setState({modalAuthVideo: true})}>شروع احراز هویت</Button>
                </section>
            </>
        )
    }

    handleInputInfoChange(name, value) {
        let {info} = this.state;
        info[name] = value;
        this.setState({info});
    }

    validationSection() {
        let {isValid, file, noChangeInfo, isUploadValidation} = this.state;

        if (isValid === "valid" || isValid === "loading" || !noChangeInfo) {
            return null;
        }

        const {fullName, nationalCode} = noChangeInfo;

        if (fullName !== "" && nationalCode !== "") {
            return (
                <section className="user-validation">
                    <p className="hint">برای ادامه مراحل نیاز به ارسال فایل اعتبارسنجی می باشد.</p>
                    <a href="https://etebarito.nics24.ir/login" target="_blank">دریافت فایل اعتبارسنجی (اعتباریتو)</a>
                    <div className="box-upload">
                        <div className="title-file">ارسال فایل اعتبارسنجی:</div>
                        <File accept="application/pdf"
                              value={file}
                              name="file"
                              multiple={false}
                              onChange={(name, value) => this.setState({[name]: value})}/>

                        <br/>
                        {
                            !isUploadValidation ?
                                <Button icon="cloud-upload" onClick={() => this.submitValidation()}>ارسال
                                    اعتبارسنجی</Button>
                                : null
                        }
                    </div>
                </section>
            )
        }

        return null;
    }

    infoSection() {
        const {info, modalTerms} = this.state;

        if (!info) {
            return null;
        }

        const {
            fullName,
            nationalCode,
            fatherName,
            birthDate,
            shenasnameh,
            postalCode,
            sokoonat,
            address,
            job,
            elatMorajeeh,
            nahveAshnayei,
            signature,
            phone
        } = info;
        if (fullName === "" ||
            signature === "" ||
            address === "" ||
            nationalCode === "" ||
            fatherName === "" ||
            birthDate === "" ||
            shenasnameh === "" ||
            sokoonat === "" ||
            elatMorajeeh === "" ||
            nahveAshnayei === "") {

            let canvasWidth = document.getElementById('parent').offsetWidth - 40;

            return (
                <section className="user-info">
                    <Modal display={modalTerms}
                           title="توافق نامه"
                           onCloseClick={() => this.setState({modalTerms: false})}>

                        <div className="content">
                            این توافق نامه فی مابین شرکت <b>مهراندیشه تکین آنوش</b> به شناسه ملی <b>۱۴۰۰۸۶۸۸۹۴۲</b>به
                            نمایندگی آقای غلامحسین رجبی وردنجانی مدیرعامل و رئیس هیئت مدیره شرکت به
                            عنوان
                            تامین
                            کننده کالا
                            (فروشنده) که از این به بعد در این توافق نامه <b>طرف اول</b> نامیده می شود
                            و آقا/خانم
                            <b>&nbsp;{fullName}&nbsp;</b> به
                            کد ملی <b>&nbsp;{nationalCode}&nbsp;</b> شماره تماس <b>&nbsp;{phone}&nbsp;</b>
                            به
                            عنوان متقاضی دریافت تسهیلات و وام که از این به بعد در این توافق نامه طرف دوم نامیده می
                            شود با
                            الزام
                            و آگاهی و رعایت موارد ذیل منعقد می گردد:
                            <br/>
                            <h3>ماده یکم:</h3>
                            <p className="made">طرف دوم توافق نامه با علم و آگاهی کامل نسبت به شرایط، ضوابط، مدارک لازم،
                                پیش
                                پرداخت نقدی و ......... اقدام به دریافت تسهیلات و وام نموده است. </p>
                            <h3>ماده دوم:</h3>
                            <p className="made">پرداخت هزینه های اولیه برابر نرخ های تعیین شده از طریق درگاه پرداخت توسط
                                طرف دوم صورت می پذیرد.</p>
                            <h3>تبصره مهم:</h3>
                            <p className="made">چنانچه طرف دوم در هر مرحله از مراحل درخواست تسهیلات به هر دلیلی از انجام
                                ادامه
                                روند انصراف دهد و یا به دلیل عدم احراز شرایط و تکمیل و ارائه مدارک لازم درخواست تسهیلات
                                خرید
                                کالای وی رد گردد، امکان مسترد نمودن هزینه های ثبت نام و جاری وجود نخواهد داشت و کلاً
                                پرداخت
                                هزینه ثبت نام تضمینی برای دریافت تسهیلات نمی باشد. </p>
                            <h3>ماده سوم:</h3>
                            <p className="made">طرف دوم متعهد می گردد که هر گونه پیامک یا اعلانی که از سمت تأمین کننده
                                مالی در
                                طرح برای وی ارسال گردید را به قید فوریت به طرف اول اعلام و ارسال نماید. لازم به ذکر است
                                که عدم
                                اطلاع رسانی مورد فوق توسط طرف دوم که باعث اخلال در روند دریافت تسهیلات گردد مسئولیتی را
                                برای طرف
                                اول ایجاد نخواهد نمود. </p>
                            <h3>ماده چهارم:</h3>
                            <p className="made">دریافت تسهیلات، وام وخرید کالا و دریافت نمودن کالا بستگی به نوع طرح و
                                پلتفرم دارد و با توجه به حجم بالای پرونده ها سه الی پنج هفته
                                بعد از تایید نهایی و تحویل مدارک و تضامین خواهد بود لازم به
                                ذکر است
                                که عدم همکاری طرف دوم در تحویل به موقع مدارک و تضامین اعلام شده موجب افزایش زمان اعلامی
                                بوده که
                                در اینصورت هیچگونه مسئولیتی متوجه طرف اول نمی باشد. </p>
                            <h4>تبصره:</h4>
                            <p className="made">متقاضی مدنظر داشته باشد با توجه به حجم بالای سفارشات احتمال سررسید اولین
                                قسط قبل
                                از تحویل کالا متصور می باشد و می بایست نسبت به پرداخت قسط اول نیز اقدام نماید و حق
                                هرگونه
                                اعتراضی را از خود سلب و ساقط می نماید.</p>
                            <h3>ماده پنجم:</h3>
                            <p className="made">طرف دوم موظف می باشد که فاکتور و گواهی تحویل گرفتن کالای خود را به صورت
                                دقیق
                                مطالعه، تکمیل و با امضاء و اثر انگشت واضح به طرف اول تحویل نماید. </p>
                            <h3>ماده ششم:</h3>
                            <p className="made">خریدار ضمن پذیرش و مسئولیت انتخاب و تحویل کالاهای موضوع قرارداد متعهد
                                گردید
                                کالاها یا کالاهای مذکور را در طول مدت قرارداد شخصا مصرف نموده و تا زمان تسویه اقساط
                                بصورت امانت
                                نزد خریدار باقی می ماند حفظ و نگهداری از کالاها به عهده خریدار می باشد. </p>
                            <h3>ماده هفتم:</h3>
                            <p className="made">اسقاط خيارات خریدار با علم و اطلاع کامل از شرایط مفاد و تعهدات توافق
                                اقدام به
                                انعقاد آن نموده و ضمن عقد خارج لازم کليه خيارات بخصوص خيار غبن فاحش بل افحش را که شفاها
                                بين
                                طرفين مبادله گردیده از خود سلب و ساقط نموده است. </p>
                            <h3>ماده هشتم:</h3>
                            <p className="made">طرف دوم اقرار می نماید که از کم و کیف و اوصاف مورد معامله و تسهیلات و
                                تعداد
                                اقساط هزینه ها ، پیش پرداخت تعداد چکهای پرداخت اقساط و تضامین و غیره اطلاع کامل و کافی
                                دارد و به
                                هیچ عنوان موضوع مبهم و مجهولی در این موارد برای وی وجود ندارد. </p>
                            <h3>ماده نهم:</h3>
                            <p className="made">طرف دوم با مطالعه دقیق و کامل اسناد و مدارک و فرمهای ثبت نام اولیه و
                                کلیه شرایط ضوابط و قوانین شرکت مهراندیشه تکین آنوش را پذیرفته و با طیب خاطر و رضای کامل
                                و از روی میل و اختیار و بدون اکراه و اجبار اقدام به درخواست تسهیلات و تشکیل پرونده نموده
                                اند.
                                این توافق نامه در دو صفحه، نه ماده و یک تبصره پس از مطالعه و با امضاء طرفین نافذ می باشد
                                که در یک نسخه تنظیم گردید .
                            </p>
                        </div>

                    </Modal>
                    <p className="hint">متقاضی عزیز! لطفا فرم زیر را با دقت تکمیل کنید:</p>
                    <form onSubmit={e => e.preventDefault()} autoComplete="off">
                        <Field name="fullName"
                               value={fullName}
                               maxLength={150}
                               focus={true}
                               label="نام و نام خانوادگی"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Field name="nationalCode"
                               value={nationalCode}
                               type="number"
                               maxLength={10}
                               style={{direction: "ltr"}}
                               label="کد ملی"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Field name="shenasnameh"
                               value={shenasnameh}
                               type="number"
                               maxLength={10}
                               style={{direction: "ltr"}}
                               label="شماره شناسنامه"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Field name="fatherName"
                               value={fatherName}
                               maxLength={80}
                               label="نام پدر"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Field name="birthDate"
                               value={birthDate}
                               maxLength={10}
                               style={{direction: "ltr"}}
                               label="تاریخ تولد (1360/05/10)"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>
                        <Field name="job"
                               value={job}
                               maxLength={250}
                               label="شغل"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>
                        <Field name="postalCode"
                               value={postalCode}
                               type="number"
                               maxLength={10}
                               style={{direction: "ltr"}}
                               label="کد پستی"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>
                        <Field
                            type="textarea"
                            name="address"
                            value={address}
                            maxLength={355}
                            label="آدرس"
                            onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Select name="sokoonat"
                                value={sokoonat}
                                label="وضعیت سکونت"
                                placeholder="وضعیت سکونت را انتخاب کنید"
                                options={[
                                    {t: "مستأجر", v: "مستأجر"},
                                    {t: "مالک", v: "مالک"},
                                ]}
                                onChange={(name, value) => this.handleInputInfoChange(name, value)}/>

                        <Field name="elatMorajeeh"
                               value={elatMorajeeh}
                               maxLength={255}
                               label="علت مراجعه"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>
                        <Field name="nahveAshnayei"
                               value={nahveAshnayei}
                               maxLength={255}
                               label="نحوه آشنایی با شرکت"
                               onChange={(name, value) => this.handleInputInfoChange(name, value)}/>
                        <div className="signature">
                            <p className="label">امضای خود را ثبت کنید</p>
                            <p className="hint">توجه داشته باشید که امضاء باید با امضای دسته چک تطابق داشته باشد!</p>
                            <SignatureCanvas penColor='black'
                                             ref={this.sigCanvas}
                                             canvasProps={{
                                                 className: 'signature-canvas',
                                                 width: canvasWidth, height: 250
                                             }}/>

                            <span className="clear" onClick={() => this.sigCanvas.current.clear()}>پاک کردن امضاء</span>

                        </div>

                        <p className="terms">با امضاء و ثبت اطلاعات، شما&nbsp;<span
                            onClick={() => this.setState({modalTerms: true})}
                            className="terms">متن توافق نامه</span>&nbsp;را می پذیرید.</p>

                        <Button submit={false} icon="check" onClick={() => this.submitInfo()}>پذیرش توافق نامه و ثبت
                            اطلاعات</Button>
                    </form>
                </section>
            )
        }

        return null;
    }
}

export default gpn(Home);